export default __webpack_public_path__ + "static/amazonFires9-c967afc9477223244172a06c498b34a2.gif";